<p-table [value]="programadores.programadores" dataKey="id" [scrollable]="true"
scrollHeight="35vh" [rowHover]="true" [tableStyle]="{ 'min-width': '50rem' }"
styleClass="p-datatable p-datatable-striped ">
<ng-template pTemplate="header">
    <tr>
        <th>Programador</th>
        <th>SSTA Totales sin finalizar</th>
        <th>Tiempo promedio sin finalizar</th>
        <th>SSTA > {{programadores.sstaXDiasFiltrado}} Días</th>
    </tr>
</ng-template>
<ng-template pTemplate="body" let-usuario>
    <tr>
        <td>{{usuario.nombre}}</td>
        <td><span class="semi-link"(click)="redirectToSSTAReportByProgrammer(usuario.nombre, false)">{{usuario.totalSinFinalizar}}</span></td>
        <td>{{usuario.tiempoPromedioSinFinalizar | comaDecimalPipe}}</td>
        <td><span class="semi-link"(click)="redirectToSSTAReportByProgrammer(usuario.nombre, true)">{{usuario.sstaXDias}}</span></td>
    </tr>
</ng-template>
<ng-template pTemplate="emptymessage" class="w-100">
    <tr>
        <td colspan="12">
            <p-messages class="w-100"
                [value]="[{ severity: 'info', detail: 'No se encontraron resultados' }]"
                [enableService]="false" [closable]="false">
            </p-messages>
        </td>
    </tr>
</ng-template>
</p-table>